export default "__VITE_ASSET__Bg2yk0XJ__"